<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="宝物信息"
      table-max-height="535px"
      expand-all-row
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      @on-reset="onResetQuery"
      :default-sort = "{prop: 'UpdateTime', order: 'descending'}"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query" >
        <el-form-item label="宝物名称" label-width="120px">
          <el-input
            v-model="params.GoodsName"
            placeholder="请输入宝物名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="宝物品牌" label-width="120px" v-if="false">
          <el-select
            v-model="params.BrandId"
            placeholder="请选择宝物品牌"
            clearable
          >
            <el-option
              v-for="(i, k) in Brands"
              :key="k"
              :label="i.BrandName"
              :value="i.RecordId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商家名称" label-width="120px" v-if="loginInfo.UserType == 0">
          <el-input
            v-model="params.BusiName"
            placeholder="请输入商家名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="平台分类" label-width="120px" v-if="loginInfo.UserType == 1">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TypePlatforms"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择平台分类"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item> -->
        <template v-if="isMallGoods">
          <el-form-item label="上架时间" label-width="120px">
            <range-picker
              ref="picker1"
              @change="
                (x) => {
                  params.GroundingTimeStart = x.Start;
                  params.GroundingTimeEnd = x.End;
                }
              "
            />
          </el-form-item>
          <el-form-item label="下架时间" label-width="120px">
            <range-picker
              ref="picker2"
              @change="
                (x) => {
                  params.OffshelfTimeStart = x.Start;
                  params.OffshelfTimeEnd = x.End;
                }
              "
            />
          </el-form-item>
          <el-form-item label="状态" label-width="120px">
            <el-select
              v-model="params.SaleState"
              placeholder="请选择上下架状态"
              clearable
            >
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="0"></el-option>
            </el-select>
          </el-form-item>
         <!-- <el-form-item label="是否热卖" label-width="120px">
            <el-select
              v-model="params.IfHot"
              placeholder="请选择是否热卖"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否爆款" label-width="120px">
            <el-select
              v-model="params.IfRecommend"
              placeholder="请选择是否爆款"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新品" label-width="120px">
            <el-select
              v-model="params.IfNew"
              placeholder="请选择是否新品"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="是否阶梯单价" label-width="120px">
            <el-select
              v-model="params.IfStep"
              placeholder="请选择是否阶梯单价"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新款打版" label-width="120px">
            <el-select
              v-model="params.IsNewStyle"
              placeholder="请选择是否新款打版"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否季末清货" label-width="120px">
            <el-select
              v-model="params.IsMonth"
              placeholder="请选择是否季末清货"
              clearable
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item> -->
        </template>
      </template>
      <template slot="table">
         <!-- <el-table-column
          prop="StoreName"
          label="所属商家"
          min-width="130px"
          v-if="$permission.isStore() == false"
        /> -->
        <el-table-column prop="GoodsName" label="宝物名称" min-width="300px" />
        <el-table-column prop="GoodsCode" label="宝物编码" min-width="130px" />
        <el-table-column prop="BrandName" label="宝物品牌" min-width="130px" v-if="false" />
        <!-- <el-table-column prop="TradeMode" label="贸易模式" min-width="80px" align="center">
          <template slot-scope="{row}">
            <span>{{ row.TradeMode == 0 ? '跨境进口' : '一般贸易' }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="LabelName" label="所属标签" min-width="120px" /> -->
        <el-table-column prop="MainUnitName" label="单位" min-width="100px" />
        <!--    <el-table-column prop="IfShelflife" label="启用保质期" min-width="80px" align="center"> 
          <template slot-scope="{row}">
            <span>{{ row.IfShelflife == 0 ? '否' : '是' }}</span>
          </template>
        </el-table-column>-->
        <!-- <el-table-column prop="AuxiliaryUnitName" label="辅单位" min-width="100px" />-->
        <!-- <el-table-column prop="AttributeName" label="商品属性" min-width="200px" /> -->
       
        <template v-if="isMallGoods">
          <el-table-column prop="GoodsCover" label="封面图" min-width="82px">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.GoodsCover"
                style="width: 60px; height: 60px"
                :src="'/api' + row.GoodsCover"
                fit="contain"
                :preview-src-list="['/api' + row.GoodsCover]"
              ></el-image>
              <span v-else>暂无图片</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="DistributionPrice" label="分销价" min-width="100px" /> -->
         
          <el-table-column
            prop="IfStep"
            label="是否阶梯单价"
            width="120px"
            align="center"
            v-if="false"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfStep == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfStep == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="OriginalPrice"
            label="原价"
            min-width="100px"
          />
          <el-table-column
            prop="PlatformPrice"
            label="销售价"
            min-width="100px"
          />
          <!-- <el-table-column prop="VirtuallySales" label="虚拟销量" min-width="100px" /> -->
          <!-- <el-table-column prop="VirtuallyInventory" label="虚拟库存" min-width="100px" /> -->
          <!-- <el-table-column prop="VirtuallyBrowse" label="虚拟浏览量" min-width="100px" /> -->
          <el-table-column
            prop="SaleState"
            label="上/下架状态"
            width="100px"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.SaleState == 1" type="success">上架</el-tag>
              <el-tag v-if="row.SaleState == 0" type="danger">下架</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="GroundingTime"
            label="最后上架时间"
            width="160px"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.GroundingTime">{{
               row.GroundingTime
              }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="OffshelfTime"
            label="最后下架时间"
            width="120px"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.OffshelfTime">{{
                $commonJs.toDateString(row.OffshelfTime)
              }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
           <el-table-column
            prop="UpdateTime"
            label="更新时间"
            width="160px"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.UpdateTime">{{
                row.UpdateTime
              }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="IfHot"
            label="是否热卖"
            width="100px"
            align="center"
            v-if="false"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfHot == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfHot == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="IfRecommend"
            label="是否爆款"
            width="100px"
            align="center"
            v-if="false"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfRecommend == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfRecommend == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="IfNew"
            label="是否新品"
            width="100px"
            align="center"
            v-if="false"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.IfNew == 1" type="success">是</el-tag>
              <el-tag v-if="row.IfNew == 0" type="danger">否</el-tag>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column
            prop="State"
            label="状态"
            width="80px"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag v-if="row.State == 0" type="danger">停用</el-tag>
              <el-tag v-else type="success">启用</el-tag>
            </template>
          </el-table-column>
        </template>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
    isMallGoods: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/goods/info").default,
      brand_api: require("@/api/goods/brand").default,
      typeplatform_api: require("@/api/goods/typeplatform").default,

      params: {
        GoodsName: "", //名称
        BrandId: null, //品牌

        State: null, //状态 - 0：停用，1：正常
        //  SaleState: null, //上下架状态 - 0：下架，1：上架
        TradeMode: 0,
        FilingsOrderids: "", //对应的保税商品备案序号
        FilingsNames: "", //对应的保税商品备案名称
        IsMonth:null,
        IsNewStyle:null,
      },
      Brands: [],
      TypePlatforms: [],
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),

      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.brand_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    });
    this.typeplatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    sortChange(column,prop,order){
      console.log(column,prop,order);
    },
    onTreeSelect(t) {
      if (!t) {
        this.params.TypeplatformIdChain = null;
      } else {
        this.params.TypeplatformIdChain = t.IdChain;
      }
    },
    onResetQuery() {
      console.log("onResetQuery", this.params);
      if (this.$refs.picker1) this.$refs.picker1.clear();
      if (this.$refs.picker2) this.$refs.picker2.clear();
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateSaleState(data) {
      this.api.updateSaleState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateRecommendState(data) {
      this.api.updateRecommendState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateHotState(data) {
      this.api.updateHotState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    updateNewState(data) {
      this.api.updateNewState(data).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>